import { render } from "./ScheduleProgramMessageTable.vue?vue&type=template&id=00ec2a9e"
import script from "./ScheduleProgramMessageTable.vue?vue&type=script&lang=js"
export * from "./ScheduleProgramMessageTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__